import { ScopeVersion } from '@app/core/model/scope-version'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ScopeSection } from '../../model/scope-section'
import { Dictionary } from 'lodash'

export function mapChangeRequestSections(
  scope: ScopeVersion,
  deliverablesBySection: Dictionary<Deliverable[]>
): ScopeSection[] {
  return [...(scope?.sections || [])]
    .sort((a, b) => a.order - b.order)
    .map((section) =>
      plainToInstance(ScopeSection, {
        ...section,
        deliverables: (deliverablesBySection[section.id] || []).sort((a, b) => a.order - b.order),
      })
    )
}
